import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 0.2s ease-in-out',
};

const baseFeedbackButtonStyles = {
  padding: '4px',
  '&:hover': {
    color: COLOR_PALETTE.BLUE[7],
    backgroundColor: COLOR_PALETTE.BLUE[1],
  },
};

export const filledFeedbackButtonStyles = {
  ...baseFeedbackButtonStyles,
  color: COLOR_PALETTE.BLUE[7],
};

export const unfilledFeedbackButtonStyles = {
  ...baseFeedbackButtonStyles,
  color: ({ palette }) => palette.text.secondary,
};
